export const EXTENTS = [
    { mode: 'mobile', width: [150, 767] },
    { mode: 'tablet', width: [768, 1199] },
    { mode: 'desktop', width: [1200, 1599] },
    { mode: 'largeScreen', width: [1600, 9999] },
    { mode: 'fixed', width: [] }
];
